module.exports = __webpack_public_path__ + "static/media/L6.a5f71f33.jpg";